import { format } from '@if/core/date'
import i18n from '@if/core/i18n'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Button, Card, CardHeader, CardProps, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { CreditAppMatchResult } from '@src/types/automationDocument'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

interface MatchProps {
  possibleMatch: CreditAppMatchResult
  variant?: CardProps['variant']
  onSelect: (possibleMatch: CreditAppMatchResult) => void
  disabled?: boolean
  selected?: boolean
}

const Match = ({ possibleMatch, variant, onSelect, disabled, selected }: MatchProps) => {
  const { t } = useTranslation()
  const cardRef = useRef<HTMLDivElement>(null)


  return (
    <Card
      ref={cardRef}
      variant={variant}
      style={{ overflow: 'visible' }}
      sx={{
        ...(selected && {
          border: 2,
          borderColor: 'primary.main',
          backgroundColor: 'action.selected',
        }),
      }}
    >
      <CardHeader
        title={
          <Stack>
            <Typography variant="caption">
              DCC #{possibleMatch.dccNumber}
              {possibleMatch.cvtNumber ? ` / CVT #${possibleMatch.cvtNumber}` : ''}
            </Typography>
            <Typography variant="inherit">{possibleMatch.formattedProductLine}</Typography>
            <Typography variant="body2" color="textSecondary">
              {possibleMatch.office}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {t('common.status')} {i18n.language == 'fr' ? possibleMatch.status : possibleMatch.statusEn}
            </Typography>
          </Stack>
        }
        action={
          <Stack direction="row" spacing={1}>
            <Tooltip title={t('common.details')}>
              <IconButton href={`${import.meta.env.VITE_API_MONOLITH_URL}${possibleMatch.link}`} target="_blank" rel="noopener noreferrer">
                <OpenInNewIcon />
              </IconButton>
            </Tooltip>
            <Button
              onClick={() => onSelect(possibleMatch)}
              disabled={disabled}
              variant={selected ? 'contained' : 'text'}
              color={selected ? 'primary' : 'inherit'}
            >
              {selected ? t('common.deselect') : t('docsAutomation.select')}
            </Button>
          </Stack>
        }
        subheader={
          <Typography variant="body2" color="textSecondary">
            {t('common.date')}: {format(possibleMatch.creationDT, 'P')}
          </Typography>
        }
      />
    </Card>
  )
}

export default Match
